module.exports = __webpack_public_path__ + "c836a792be97f7378c91c53c55967ac3.pdf";